import { getHttpClient, SocialApi } from '@capsicum/common';

export const socialApi = getHttpClient.then(c => new SocialApi(c));
